import ConnectedPageModel from '@mm/state/model/ConnectedPageModel';
import { UpdateGuard, RetrieveFbPost, SetErrorMessage } from './types';
import { POST_NOT_FOUND } from './constants';

export const getPostFromUrl = (url: string) => {
  const storyPost = url.match(/[^](fbid=[0-9]{9})\d+/);
  if (storyPost !== null) {
    return storyPost[0].replace('?fbid=', '').replace('_fbid=', '');
  }

  const regularPost = url.match(/(posts\/[0-9]{9})\d+/);
  if (regularPost !== null) {
    return regularPost[0].replace('posts/', '');
  }

  const postId = parseInt(url, 10);
  return isNaN(postId) ? '' : url;
};

export const retrieveAndUpdatePostInfo = async (
  retrieveFbPost: RetrieveFbPost,
  updateGuard: UpdateGuard,
  connectedPage: ConnectedPageModel | undefined,
  foundPost: string,
  setErrorMessage: SetErrorMessage,
) => {
  if (connectedPage && connectedPage.id) {
    const postInfo = await retrieveFbPost(connectedPage.id, foundPost);
    if (postInfo) {
      updateGuard(postInfo);
      setErrorMessage('');
    } else {
      setErrorMessage(POST_NOT_FOUND);
    }

    return postInfo;
  }
};
